import { makeStyles } from "@material-ui/core/styles";

const theme = props => {
    const styles = makeStyles(() => ({
        container: {
            marginBottom: 15,
            padding: 20,

            '& .title': {
                color: '#374151',
                fontWeight: 500,
                fontSize: 20,
                marginBottom: 20,
            },
            '& .text': {
                fontSize: 13,
                fontWeight: 400,
                color: '#989898',
                marginBottom: 30,
            },
        },
        '@media (max-width: 600px)': {
            container: {
                padding: 14,
                '& .title': {
                    fontSize: 'var(--mobile-title-size)',
                    color: 'var(--text-strong)',
                    fontWeight: 600,
                    lineHeight: 'var(--lh-title)',
                    marginBottom: 8,
                },
                '& .label': {
                    fontSize: 'var(--mobile-label-size)',
                    color: 'var(--text-muted)',
                    fontWeight: 500,
                },
                '& .text': { 
                    fontSize: 'var(--mobile-body-size)',
                    color: 'var(--text-body)',
                    lineHeight: 'var(--lh-body)',
                    fontWeight: 400,
                    marginBottom: 16,
                },
            }
        },
    }));
    return styles();
};

export default theme;